<template>
  <div id="app" :style="computedStyles">
    <Home v-if="routeName" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Home from '@/views/Home.vue'
export default {
  name: 'App',
  components: {
    Home,
  },
  computed: {
    ...mapGetters({
      platform: 'platform',
    }),
    computedStyles() {
      const styles = {}
      if (this.$route.name === 'Index') {
        styles['margin-left'] = 'calc(100vw - 101%)'
      }
      if (this.$route.name === 'File') {
        styles['overflow-y'] = 'hidden'
      }
      return styles
    },
    routeName() {
      return this.$route.name
    },
  },
  async created() {
    const html = document.getElementById('html')
    html.setAttribute('platform', this.platform)
    // 引入广小二
    window.GlodonRobotJsSDK.load('https://robot.glodon.com/client/main.html?app=GJW&channel=4-b05a28748b65484eb468305aaec72360&type=plugin')
    // 获取配置文件
    await this.loadConfig({ key: 'linkUrls', fileName: 'link-urls.json' })
  },
  methods: {
    ...mapActions({
      loadConfig: 'staticConfig/loadConfig',
    })
  },
}
</script>

<style lang="less" scoped>
#app {
  height: 100%;
}
</style>
